import { render, staticRenderFns } from "./SocialWallCommentsModal.vue?vue&type=template&id=9359d91c&scoped=true"
import script from "./SocialWallCommentsModal.vue?vue&type=script&lang=js"
export * from "./SocialWallCommentsModal.vue?vue&type=script&lang=js"
import style0 from "./SocialWallCommentsModal.vue?vue&type=style&index=0&id=9359d91c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9359d91c",
  null
  
)

export default component.exports